import ADMIN_DASHBOARD_ROUTE from './adminDashboardRoute';
import ADMIN_DOCUMENTS_ROUTE from './adminDocumentsRoute';
import GROUPS_ROUTE from './groupsRoute';
import HISTORY_ROUTE from './historyRoute';
import PENDING_HIRES_ROUTE from './pendingHiresRoute';
import PERMISSIONS_ROUTE from './permissionsRoute';
import PLATFORM_SETTINGS_ROUTE from './platformSettingsRoute';
import PROFILE_SETUP_ROUTE from './profileSetupRoute';
import OUTBOX_ROUTE from './outboxRoute';
import REPORTS_ROUTE from './reportsRoute';
import TIME_OFF_ROUTE from './timeOffRoute';
import WORKFLOWS_ROUTE from './workflowsRoute';
import INTEGRATIONS_PAGE_ROUTE from './integrationsPageRoute';
import TIME_OFF_PAYWALL_ROUTE from './timeOffPaywallRoute';
import WORKING_PATTERNS_ROUTE from './workingPatternsRoute';
import ABSENCE_MANAGEMENT_ROUTE from './absenceManagementRoute';

export default [
  {
    ...ADMIN_DASHBOARD_ROUTE,
    orderInGroup: 10,
  },
  {
    ...REPORTS_ROUTE,
    orderInGroup: 20,
  },
  {
    ...HISTORY_ROUTE,
    orderInGroup: 30,
  },
  {
    ...PENDING_HIRES_ROUTE,
    orderInGroup: 35,
  },
  {
    ...PROFILE_SETUP_ROUTE,
    orderInGroup: 40,
  },
  {
    ...WORKFLOWS_ROUTE,
    orderInGroup: 50,
  },
  {
    ...ADMIN_DOCUMENTS_ROUTE,
    orderInGroup: 60,
  },
  {
    ...OUTBOX_ROUTE,
    orderInGroup: 70,
  },
  {
    ...TIME_OFF_ROUTE,
    orderInGroup: 80,
  },
  {
    ...TIME_OFF_PAYWALL_ROUTE,
    orderInGroup: 82,
  },
  {
    ...WORKING_PATTERNS_ROUTE,
    orderInGroup: 86,
  },
  {
    ...ABSENCE_MANAGEMENT_ROUTE,
    orderInGroup: 88,
  },
  {
    ...PERMISSIONS_ROUTE,
    orderInGroup: 90,
  },
  {
    ...PLATFORM_SETTINGS_ROUTE,
    orderInGroup: 100,
  },
  {
    ...GROUPS_ROUTE,
    orderInGroup: 110,
  },
  {
    ...INTEGRATIONS_PAGE_ROUTE,
    orderInGroup: 120,
  },
];
